'use client';
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import classnames from 'classnames';
import { Button } from '../../components/Button/Button.js';
export const ShowMore = (_a) => {
    var { className, isActive, children, buttonVariant = 'link', buttonText = 'Show More', hideButtonText = 'Show Less', hiddenContent, iconName, iconPosition, hideButtonAfterActive = false } = _a, other = __rest(_a, ["className", "isActive", "children", "buttonVariant", "buttonText", "hideButtonText", "hiddenContent", "iconName", "iconPosition", "hideButtonAfterActive"]);
    const [isActiveVar, setIsActive] = React.useState(isActive ? isActive : false);
    const handleClick = () => {
        setIsActive(!isActiveVar);
    };
    const componentClassName = classnames('sparky-c-show-more', className, {
        'sparky-is-active': isActiveVar,
    });
    return (_jsxs("div", Object.assign({ className: componentClassName }, other, { children: [children, _jsx("div", Object.assign({ className: "sparky-c-show-more__panel", hidden: !isActiveVar }, { children: hiddenContent })), hideButtonAfterActive && isActiveVar === true ? null : (_jsx(Button, { onClick: handleClick, className: "sparky-c-radio-field__show-more-button", variant: buttonVariant, text: isActiveVar === true ? hideButtonText : buttonText, iconPosition: iconPosition, iconName: iconName, size: "sm" }))] })));
};
//# sourceMappingURL=ShowMore.js.map